import { QueryClient } from "@tanstack/react-query"
import type { AxiosError } from "axios"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: (failureCount, error: unknown) => {
        const axiosError = error as AxiosError
        if (axiosError?.response?.status === 401 || axiosError?.response?.status === 403) {
          return false
        }
        return failureCount < 3
      },
      throwOnError: (error: unknown) => {
        const axiosError = error as AxiosError
        if (axiosError?.response?.status === 401 || axiosError?.response?.status === 403) {
          return false
        }
        return true
      },
    },
    mutations: {
      retry: (failureCount, error: unknown) => {
        const axiosError = error as AxiosError
        const status = axiosError?.response?.status
        if (status && status >= 400 && status < 500) {
          return false
        }
        return failureCount < 1
      },
      throwOnError: (error: unknown) => {
        const axiosError = error as AxiosError
        const status = axiosError?.response?.status
        if (status && status >= 400 && status < 500) {
          return false
        }
        return true
      },
    },
  },
})
